// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"293":"5f852313","952":"2628c9fa"}[chunkId] + ".chunk.js";
};